import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

var ErrorResponse = /*#__PURE__*/function () {
  function ErrorResponse() {
    _classCallCheck(this, ErrorResponse);

    /**
     * @type {?number}
     */
    this.status = null;
    /**
     * @type {?Object}
     */

    this.data = null;
    /**
     * @type {?Object}
     */

    this.headers = null;
  }
  /**
   * @returns {?number}
   */


  _createClass(ErrorResponse, [{
    key: "getStatus",
    value: function getStatus() {
      return this.status;
    }
    /**
     * @param {?number} value
     *
     * @returns {ErrorResponse}
     */

  }, {
    key: "setStatus",
    value: function setStatus(value) {
      this.status = value;
      return this;
    }
    /**
     * @returns {?Object}
     */

  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
    /**
     * @param {?Object} value
     *
     * @returns {ErrorResponse}
     */

  }, {
    key: "setData",
    value: function setData(value) {
      this.data = value;
      return this;
    }
    /**
     * @returns {?Object}
     */

  }, {
    key: "getHeaders",
    value: function getHeaders() {
      return this.headers;
    }
    /**
     * @param {?Object} value
     *
     * @returns {ErrorResponse}
     */

  }, {
    key: "setHeaders",
    value: function setHeaders(value) {
      this.headers = value;
      return this;
    }
  }]);

  return ErrorResponse;
}();

export { ErrorResponse as default };